<template>
    <div class="modal fade" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel" aria-hidden="true" id="search-note">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">
                        <i class="fas fa-search"></i>
                        ノートの検索と置換
                    </h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="form-group">
                        <label>検索</label>
                        <div class="input-group">
                            <input type="text" id="note-keyword" class="form-control" v-model="keyword"
                                placeholder="検索文字列（Enterで検索）"
                                @focus="select('note-keyword')"
                                @keydown.enter="find($event)" />
                            <div class="input-group-append">
                                <button class="btn btn-secondary btn-sm" type="button" @click="find()" :disabled="keyword.length == 0">
                                    すべて検索
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="form-group" v-if="results.length">
                        <label>置換</label>
                        <div class="input-group">
                            <input type="text" id="note-replace" class="form-control" v-model="replace"
                                placeholder="置換文字列"
                                @focus="select('note-replace')" />
                            <div class="input-group-append">
                                <button class="btn btn-sm" :class="{
                                    'btn-warning': replace.length,
                                    'btn-danger': !replace.length,
                                }" type="button" @click="replaceAll()">
                                    <span v-if="replace.length">すべて置換</span>
                                    <span v-else>すべて削除</span>
                                </button>
                            </div>
                        </div>
                        <div class="small" :class="{
                            'text-warning': replace.length,
                            'text-danger': !replace.length,
                        }">
                            <span v-if="replace.length">検索結果をすべて指定文字列で置換します。</span>
                            <span v-else>検索結果をすべて指定文字列で削除します。</span>
                        </div>
                    </div>
                </div>
                <div class="modal-body" v-if="finded || results.length">
                    <div class="list-group" v-if="results.length">
                        <a href="#" class="list-group-item list-group-item-action small"
                            v-for="(r, i) in results" :key="i"
                            @click="found(r)">
                            <div class="d-inline-block text-primary" :title="r.caption" data-toggle="tooltip">
                                {{$filters.truncate(r.caption, 9)}}
                            </div>
                            <div class="d-inline-block ml-3" v-html="result(r.sample)"></div>
                        </a>
                    </div>
                    <div class="small text-warning" v-else>
                        検索結果はありません: {{finded}}
                    </div>
                </div>
                <div class="modal-body" v-else>
                    <div class="small text-muted">
                        古いフォーマットのノートは検索機能が使えません。<br>
                        ノート本文を１文字でも編集して保存することで、新フォーマットに自動変換します。
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-outline-secondary" data-dismiss="modal">閉じる</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        book_id: {
            default: null,
        },
    },
    data() {
        return {
            keyword: "",
            replace: "",
            results: [],
            finded: "",
        }
    },
    methods: {
        find(ev = null) {
            if (ev && ev.keyCode !== 13) return;
            if (this.keyword.length == 0) return;
            axios.get("/mypage/book/notes/search", { params: {
                keyword: this.keyword,
                book_id: this.book_id,
            }}).then(res => {
                const regex = new RegExp(this.keyword.replace(/[\\^$.*+?()[\]{}|]/g, '\\$&'), "umg");
                let memo;
                this.results = [];
                for (let r of res.data) {
                    memo = null;
                    try {
                        memo = JSON.parse(r.memo);
                        for (const index in memo.blocks) {
                            const block = memo.blocks[index];
                            let strings = [];
                            if (block.data.text) {
                                // 本文とヘッダ
                                strings.push(block.data.text);
                            } else if (block.data.items) {
                                // リスト
                                for (const item of block.data.items) {
                                    if (item.text) {
                                        strings.push(item.text);
                                    } else {
                                        strings.push(item);
                                    }
                                }
                            } else if (block.data.content) {
                                for (const row of block.data.content) {
                                    strings.push(row.join("\t"));
                                }
                            } else if (block.data.caption) {
                                strings.push(block.data.caption);
                            }
                            let row = strings.join("\n");
                            let pos;
                            while(pos = regex.exec(row)) {
                                let sample = "";
                                if (pos) {
                                    if (pos.index > 15) {
                                        sample = "…" + row.substring(pos.index - 15);
                                    } else {
                                        sample = row;
                                    }
                                    if (sample.length > 55) {
                                        sample = sample.substring(0, 55) + "…";
                                    }
                                    this.results.push({
                                        index: index,
                                        caption: r.caption || "（無題）",
                                        sample: sample,
                                        id: r.id,
                                        keyword: this.keyword
                                    });
                                }
                            }
                        }
                    } catch (error) {
                        if (error.name && error.name === "SyntaxError") {
                            alert.warn("「" + r.caption + "」 は古いフォーマットです。編集して保存することで新フォーマットに変換してください。", "旧フォーマット警告");
                        }
                        console.error(error);
                    }
                }
                this.finded = this.keyword;
                setTimeout(() => {$('[data-toggle="tooltip"]').tooltip()});
            }).catch(err => { alert.err(err.response) });
        },
        replaceAll() {
            const replaceEvent = () => {
                this.$emit("replace", {
                    keyword: this.keyword,
                    replace: this.replace,
                });
                $("#search-note").modal("hide");
            };
            if (!this.replace.length) {
                Swal.fire({
                    title: "文字列削除",
                    text: `ご指定の検索文字列 "${this.keyword}" をこの小説の全てのノートから削除します。よろしいですか？`,
                    icon: "error",
                    showCancelButton: true,
                    confirmButtonText: "削除",
                    cancelButtonText: "キャンセル",
                    confirmButtonColor: "crimson",
                    cancelButtonColor: "gray",
                    reverseButtons: true,
                }).then(confirm => {
                    if (confirm.isConfirmed) {
                        replaceEvent();
                    }
                });
            } else {
                replaceEvent();
            }
        },
        result(body) {
            const regex = new RegExp('(' + this.keyword.replace(/[\\^$.*+?()[\]{}|]/g, '\\$&') + ')', "ug");
            return body.replace(regex, "<b>$1</b>");
        },
        select(id) {
            $("#" + id).select();
        },
        found(r) {
            this.$emit('found', r);
            $("#search-note").modal("hide");
        }
    },
    mounted() {
        $("#search-note").on("shown.bs.modal", (e) => {
            $("#note-keyword").focus();
            setTimeout(() => {
                $("#note-keyword").focus();
            }, 500);
        });
    }
}
</script>